import "./CaseStudies.module.css";
import Header from "@/reusable_sections/Header";
import Impact from "./sections/Impact";
import Testimonials from "./sections/Testimonials";
import ReadyToCreateImpact from "./sections/ReadyToCreateImpact";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesPage() {
  return <div>
      <Header />
      <Impact />
      <Testimonials />
      <ReadyToCreateImpact />
      <Footer />
    </div>;
}